import * as React from 'react';
import styled from '@emotion/styled';
import { useState } from 'react';
import { __ } from '../../helpers/TranslationService';
import { IMobileWaypoint } from '../../interfaces';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import { FlagIcon } from '../Icons/FlagIcon';

interface IProps {
    waypoints: IMobileWaypoint[];
}

const compName = 'routes-list';

const ArrowDownIconStyled = styled(ArrowDownIcon)`
    fill: ${({ theme }) => theme.icon.brandColor1};
`;

const RoutesList = (props: IProps) => {
    const [activeItem, setActiveItem] = useState(null);

    const { waypoints } = props;

    if (waypoints?.length <= 0) return null;

    const hanndleCollapsibleBtn = (i) => {
        setActiveItem(i);
    };
    let isEmbarked: boolean = false;

    return (
        <section className={`${compName}`}>
            <table className={`${compName}__table`}>
                <thead className={`${compName}__thead`}>
                    <tr>
                        <ThWrap>
                            <p>{__('Day', 'dreamlines')}</p>
                        </ThWrap>
                        <ThWrap>
                            <p>{__('travel station', 'dreamlines')}</p>
                        </ThWrap>
                        <ThWrap>{''}</ThWrap>
                        <ThWrap>{''}</ThWrap>
                        <ThWrap>
                            <p>{__('Infos', 'dreamlines')}</p>
                        </ThWrap>
                    </tr>
                </thead>
                <tbody>
                    {waypoints.map((waypoint, i) => {
                        const {
                            day,
                            title,
                            arrival,
                            departure,
                            isPortOfEmbarkation = false,
                            isPortOfDisembarkation = false,
                            info,
                        } = waypoint;

                        const isActualWayPoint =
                            !!waypoint &&
                            (!!waypoint.arrival || !!waypoint.image || !!waypoint.description);
                        const evenOddClassName = i % 2 === 0 ? 'odd' : 'even';
                        const setEmbarked = () => {
                            if (isPortOfDisembarkation || isPortOfEmbarkation) {
                                if (isPortOfDisembarkation) {
                                    isEmbarked = false;
                                } else {
                                    isEmbarked = true;
                                }
                            }
                        };
                        return (
                            <React.Fragment key={`waypoint-${i}`}>
                                <tr
                                    className={`${compName}__tbody__tr ${evenOddClassName}`}
                                    onClick={() =>
                                        isActualWayPoint &&
                                        hanndleCollapsibleBtn(activeItem !== i ? i : null)
                                    }
                                >
                                    <TdWrap>
                                        <>
                                            {day && String(day)}
                                            {Boolean(
                                                isPortOfDisembarkation || isPortOfEmbarkation,
                                            ) && (
                                                <FlagIcon
                                                    width={14}
                                                    height={14}
                                                    className={`${compName}__td__flag`}
                                                />
                                            )}
                                        </>
                                    </TdWrap>
                                    <TdWrap>
                                        <>
                                            {title?.length > 0 && __(title, 'dreamlines')}
                                            <SmallDescr
                                                isPortOfEmbarkation={isPortOfEmbarkation}
                                                isPortOfDisembarkation={isPortOfDisembarkation}
                                                info={info}
                                                isEmbarked={isEmbarked}
                                            />
                                        </>
                                    </TdWrap>
                                    <TdWrap>{arrival?.length > 0 && arrival}</TdWrap>
                                    <TdWrap>{departure?.length > 0 && departure}</TdWrap>
                                    <TdWrap>
                                        {isActualWayPoint && (
                                            <div className={`${compName}__td__toggle-collapsible`}>
                                                <div
                                                    className={`${compName}__td__toggle-collapsible__inner-holder ${
                                                        activeItem !== null && activeItem === i
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                >
                                                    <ArrowDownIconStyled width={16} height={16} />
                                                </div>
                                            </div>
                                        )}
                                    </TdWrap>
                                </tr>
                                {!!waypoint && (
                                    <tr className={`${compName}__tbody__tr ${evenOddClassName}`}>
                                        <td
                                            className={`${compName}__td collapsible ${
                                                activeItem !== null && activeItem === i
                                                    ? 'open'
                                                    : ''
                                            }`}
                                            colSpan={5}
                                        >
                                            <div className={`${compName}__td__collapsible-inner`}>
                                                <div
                                                    className={`${compName}__td__collapsible-inner__square`}
                                                ></div>
                                                <div
                                                    className={`${compName}__td__collapsible-inner__arrival-departure`}
                                                >
                                                    {!!waypoint?.arrival && (
                                                        <span>
                                                            {`${__('at', 'dreamlines')} ${
                                                                waypoint.arrival
                                                            }`}
                                                        </span>
                                                    )}
                                                    {departure && (
                                                        <span>{`${__(
                                                            'off',
                                                            'dreamlines',
                                                        )} ${departure}`}</span>
                                                    )}
                                                </div>
                                                {!!waypoint?.image && (
                                                    <img
                                                        src={waypoint.image}
                                                        alt={waypoint.title}
                                                    />
                                                )}
                                                {!!waypoint?.description && (
                                                    <div
                                                        className={`${compName}__td__collapsible-inner__description`}
                                                        dangerouslySetInnerHTML={{
                                                            __html: waypoint.description,
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {setEmbarked()}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </section>
    );
};

interface IChildren {
    children: JSX.Element | JSX.Element[] | string | string[];
}

const ThWrap = ({ children }: IChildren) => {
    return <th className={`${compName}__th`}>{children}</th>;
};

const TdWrap = ({ children }: IChildren) => {
    return <td className={`${compName}__td`}>{children}</td>;
};

const SmallDescrWrap = ({ children }: IChildren) => {
    return <small className={`${compName}__small-descr`}>{children}</small>;
};

interface ISmallDescr {
    isPortOfEmbarkation: boolean;
    isPortOfDisembarkation: boolean;
    info: string[];
    isEmbarked: boolean;
}

const SmallDescr = ({
    isPortOfEmbarkation,
    isPortOfDisembarkation,
    info,
    isEmbarked,
}: ISmallDescr) => {
    let infoEnd = [];
    return (
        <>
            {isPortOfDisembarkation && (
                <SmallDescrWrap>{__('Disembarkment', 'dreamlines')}</SmallDescrWrap>
            )}
            {info?.length > 0 &&
                info.map((inf, i) => {
                    if (!isEmbarked && inf === 'Übernachtung an Bord') {
                        infoEnd.push(inf);
                        return null;
                    }
                    return <SmallDescrWrap key={`small-descr-${i}`}>{inf}</SmallDescrWrap>;
                })}
            {isPortOfEmbarkation && (
                <SmallDescrWrap>{__('Embarkment', 'dreamlines')}</SmallDescrWrap>
            )}
            {infoEnd?.length > 0 &&
                infoEnd.map((inf, i) => (
                    <SmallDescrWrap key={`small-descr-${i}`}>{inf}</SmallDescrWrap>
                ))}
        </>
    );
};

export default RoutesList;
